import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { c as y } from "../../../index-Cu0xwYjD.js";
import { forwardRef as d } from "react";
import { isExternalLink as z } from "../../utils/utils.js";
import { s as e } from "../../../Button.module-C__9MZHi.js";
import { Icon as a } from "../Icon/Icon.js";
import { VisuallyHidden as b } from "../VisuallyHidden/VisuallyHidden.js";
import '../../../assets/Link.css';const L = "_inline_176jz_4", T = {
  inline: L
}, E = d(
  ({
    variant: r = "surface",
    iconRight: n = "off",
    iconLeft: t = "off",
    inline: f = !1,
    inverted: p = !1,
    children: u,
    className: c,
    fullWidth: k,
    href: l,
    opensInNewWindow: i,
    rel: o,
    target: x,
    ..._
  }, j) => {
    const w = i ? "_blank" : x;
    return z(l) && (o = `${o || ""} noopener`.trim()), n === "off" && i && (n = "new-window"), /* @__PURE__ */ m(
      "a",
      {
        ref: j,
        rel: o,
        target: w,
        href: l,
        className: y(
          !f && e.button,
          {
            ...e[r] && { [e[r]]: !0 },
            [e.fullWidth]: k,
            [e.inverted]: p,
            [T.inline]: f
          },
          c
        ),
        ..._,
        children: [
          t !== "off" ? /* @__PURE__ */ s(a, { name: t, size: 16 }) : null,
          /* @__PURE__ */ m("span", { children: [
            u,
            i && /* @__PURE__ */ s(b, { children: " (opens in new window)" })
          ] }),
          n !== "off" ? /* @__PURE__ */ s(a, { name: n, size: 16 }) : null
        ]
      }
    );
  }
), A = d(
  (r, n) => /* @__PURE__ */ s(E, { inline: !0, ref: n, ...r })
);
export {
  E as Link,
  A as TextLink
};
